import dayjs from 'dayjs';
import { isNaN } from 'lodash';

import { relationshipKeys } from 'constants/defaultValues';
import { ContentRoutes } from 'enums/routes';

export const handleObjectString = (obj: GenericObject, name: string): any => {
  const names = name?.split('.');
  let parsedObject = obj || {};
  names?.forEach((key) => {
    parsedObject = parsedObject?.[key] ?? null;
  });

  return parsedObject;
};

export const parseQuerySearchToArray = (search) => {
  const parsedSearch = [];
  new URLSearchParams(search).forEach((value, key) => {
    parsedSearch.push({ key, value });
  });
  return parsedSearch;
};

export const relationshipToOption = (relationship, key) => ({
  id: relationship.id,
  label: relationship[key],
});

export const parseDefaultValue = (key, value, content) => {
  if (key === 'address') {
    const values = {};
    Object.entries(value ?? {}).forEach(([subKey, data]) => {
      values[subKey] = parseDefaultValue(subKey, data, content);
    });
    return values;
  }
  if (key === 'containerType') {
    return value ?? 'null';
  }
  if (key === 'city' || key === 'state') {
    return {
      label: value,
      name: value,
    };
  }
  if (key === 'contents') {
    return value;
  }
  if (key === 'type' && content !== ContentRoutes.Materials) {
    return {
      label: value,
      value,
    };
  }
  if (value && typeof value === 'object') {
    if (Array.isArray(value)) {
      return value.map(((item) => parseDefaultValue(key, item, content)));
    }
    return relationshipToOption(value, relationshipKeys[key]);
  }
  return value;
};

export const parseAddressOption = (address) => ({
  ...address,
  city: address.city.name,
  state: address.state.name,
});

export const formatDatePicker = ({ day, month, year }) => {
  const date = dayjs().date(day).month(month - 1).year(year);

  return date.format('DD/MM/YYYY');
};

export function getPercentage(value, total) {
  const result = (value / total) * 100;
  if (isNaN(result)) {
    return 0;
  }
  return result;
}
